import React from "react";
import PropTypes from "prop-types";
import Icon from "../../ui/icon/icon";
import './miniTab.css';

export default function MiniTab({
    panes,
    activeTab,
    onTabSelected,
    className
}) {
    return (
        <div className={`wz-minitab ${className}`}>
            <div className="wz-minitab__menuItems">
                {panes.map((tab, index) => {
                    return (
                        <span
                            key={`item-${index}`}
                            className={`wz-minitab__item${
                                tab.value === activeTab
                                    ? " wz-minitab__active"
                                    : ""
                            }${tab.disabled ? " wz-minitab__disabled" : ""}`}
                            onClick={() => {
                                if (!tab.disabled) {
                                    if (onTabSelected) {
                                        onTabSelected(tab, index);
                                    }
                                }
                            }}
                        >
                            <span
                                className={`wz-minitab__item-content${
                                    tab.value === activeTab
                                        ? " wz-minitab__item-content__active"
                                        : ""
                                }`}
                            >
                                {tab.icon && (
                                    <Icon
                                        className="wz-minitab__item-content-icon"
                                        name={tab.icon}
                                    />
                                )}
                                <span className="wz-minitab__text">
                                    {tab.label}
                                </span>
                            </span>
                        </span>
                    );
                })}
            </div>
        </div>
    );
}

MiniTab.propTypes = {
    panes: PropTypes.arrayOf(
        PropTypes.shape({
            label: PropTypes.string.isRequired,
            value: PropTypes.string.isRequired,
            icon: PropTypes.string,
            disabled: PropTypes.bool
        })
    ).isRequired,
    onTabSelected: PropTypes.func,
    activeTab: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    className: PropTypes.string
};

MiniTab.defaultProps = {
    onTabSelected: null,
    activeTab: null,
    className: ""
};
